"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M12 18.64c.55 0 1-.3 1-.67l-.43-1.9c.25-.18.43-.47.43-.8 0-.56-.45-1.01-1-1.01s-1 .45-1 1.01a.96.96 0 0 0 .43.8l-.43 1.9c0 .37.45.67 1 .67Z"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M20 8.89h-2V6.04C18 2.7 15.31 0 12 0S6 2.71 6 6.04v2.85H4c-.55 0-1 .45-1 1V23c0 .55.45 1 1 1h16c.55 0 1-.45 1-1V9.89c0-.55-.45-1-1-1ZM8 6.04C8 3.81 9.79 2 12 2s4 1.81 4 4.04v2.84H8V6.04ZM5 22V10.89h14V22H5Z",
    clipRule: "evenodd"
  })]
});